import { triada } from '@/app/helpers';
import { BriefData } from '@/entities/ihamkor/types';
import { TFunction } from 'i18next';
import { patternFormatter } from 'react-number-format';

export const getBriefDataFields = (t: TFunction, data?: BriefData) => {
  if (!data) return [];
  const phoneNumber = (data.phone || '').replace(/\D/g, '').slice(-9);
  return [
    {
      termKey: 'name_full',
      value: data.name,
    },
    {
      termKey: 'name_short',
      value: data.shortName,
    },
    {
      termKey: 'manager',
      value: data.directorFullName,
    },
    {
      termKey: 'phone_number',
      value: patternFormatter(phoneNumber, {
        format: '+998 (##) ###-##-##',
      }),
    },
    {
      termKey: 'email_address',
      value: data.email,
    },
    {
      termKey: 'registered_full_legal_address',
      value: data.billingAddress,
    },
    {
      termKey: 'condition',
      value: data.status,
    },
    {
      termKey: 'condition_change_date',
      value: data.statusUpdated,
    },
    {
      termKey: 'opf',
      value: data.opf,
    },
    {
      termKey: 'oked',
      value: data.oked,
    },
    {
      termKey: 'soato',
      value: data.soato,
    },
    {
      termKey: 'soogu',
      value: data.soogu,
    },
    {
      termKey: 'okpo',
      value: data.okpo,
    },
    {
      termKey: 'vat_payer_type',
      value: data.companyType,
    },
    {
      termKey: 'company_category',
      value: data.businessType,
    },
    {
      termKey: 'form_of_ownership_kfs',
      value: data.kfs,
    },
    {
      termKey: 'registration_date',
      value: data.registrationDate,
    },
    {
      termKey: 'reg_number',
      value: data.registrationNumber,
    },
    {
      termKey: 'registration_authority',
      value: data.registrationAuthority,
    },
    {
      termKey: 'date_of_re_registration',
      value: data.reregistrationDate,
    },
    {
      termKey: 'date_of_end_of_activity',
      value: data.liquidationDate,
    },
    {
      termKey: 'tax_regime',
      value: data.taxMode,
    },
    {
      termKey: 'vat_certificate_number',
      value: data.vatNumber,
    },
    {
      termKey: 'vat_cert_status',
      value: data.vatStatus,
    },
    {
      termKey: 'size_of_authorised_capital',
      value:
        triada(data?.businessFund || '', {
          decimal: 2,
        }) + ' сум',
    },
    {
      termKey: 'presence_in_dubious_list',
      value: data.isSuspicious ? t('ihamkor.yes') : t('ihamkor.no'),
    },
  ];
};
